import React, {Component} from 'react';
import {Container} from "react-bootstrap";
import styles from './Policy.module.css';

class Policy extends Component {
	render() {
		return (
			<Container className="mt-5">
				<section>
					<h1 className={styles.title}>Политика конфиденциальности</h1>
					<p><strong>ООО «4 Цвета»</strong></p>

					<h2>1. Сбор персональных данных</h2>
					<p>
						Мы собираем следующие персональные данные, которые вы добровольно предоставляете нам через форму
						обратной связи:
					</p>
					<ul>
						<li>Имя</li>
						<li>Адрес электронной почты</li>
					</ul>

					<h2>2. Цель обработки данных</h2>
					<p>
						Собранные персональные данные используются <strong>исключительно</strong> для обратной связи с
						вами по вашему запросу или обращению.
					</p>
					<p>
						Мы <strong>не используем</strong> эти данные в маркетинговых целях, не передаём третьим лицам и
						не публикуем их.
					</p>

					<h2>3. Хранение и защита данных</h2>
					<p>
						Мы принимаем все разумные меры для защиты ваших персональных данных от утраты, неправомерного
						доступа, изменения или раскрытия.
					</p>
					<p>
						Данные хранятся в течение срока, необходимого для ответа на ваш запрос, но не более 12 месяцев с
						момента получения, после чего автоматически удаляются.
					</p>

					<h2>4. Права пользователя</h2>
					<p>Вы имеете право:</p>
					<ul>
						<li>Запросить информацию о ваших персональных данных, хранящихся у нас</li>
						<li>Требовать их изменения или удаления</li>
						<li>Отозвать своё согласие на обработку данных, обратившись к нам по контактам, указанным ниже
						</li>
					</ul>

					<h2>5. Контактная информация</h2>
					<p>Если у вас возникли вопросы, предложения или вы хотите воспользоваться своими правами в отношении
						персональных данных, пожалуйста, свяжитесь с нами:</p>
					<p><strong>ООО «4 Цвета»</strong><br/>
						Email: 4zveta@mail.ru<br/>
						Телефон: 783-064
					</p>
				</section>

			</Container>
		);
	}
}

export default Policy;
